import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const CalendarPickup = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default CalendarPickup;
